<template>
  <div
    ref="labelRef"
    class="d-flex align-center"
    style="word-break: break-all;"
  >
    <div
      v-if="mostrarIcones"
      :class="`d-flex ${mostrarIcones ? 'mr-2' : ''}`"
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        :vertical="iconsVertical"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </div>

    <span class="text-justify">{{ textoFormatado }}</span>
  </div>
</template>

<script>
import { computed, nextTick, onMounted, ref } from '@vue/composition-api'
import ComponenteBase from './ComponenteBase.vue'
import Icons from './Icons.vue'
import textComponentMixin from '@/mixins/textComponentMixin'
import ComponenteTextLabelOptions from '@/models/props/ComponenteTextLabelOptions'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [textComponentMixin],

  props: {
    texto: {
      type: String,
      required: true,
    },
    textLabelOptions: {
      type: ComponenteTextLabelOptions,
      default: null,
    },
  },

  setup(props) {
    const iconsVertical = ref(false)

    const textoFormatado = computed(() => {
      const { textLabelOptions } = props
      let { texto } = props

      if (!textLabelOptions) return texto

      texto = texto.replaceAll('solicitanteNome', textLabelOptions.solicitanteNome)
      texto = texto.replaceAll('enderecoFormatado', textLabelOptions.enderecoFormatado)
      texto = texto.replaceAll('empresaNome', textLabelOptions.empresaNome)

      return texto
    })

    const labelRef = ref(null)

    onMounted(async () => {
      if (!props.mostrarIcones) return
      await nextTick()
      iconsVertical.value = labelRef.value.getBoundingClientRect().height > 50
    })

    return {
      iconsVertical,
      textoFormatado,
      labelRef,
    }
  },
}
</script>
